export interface Testimonial {
  name: string
  position: { en: string; fr?: string; de?: string }
  company: string
  icon: string
  image: string
  link: string
  video?: {
    imageSrc?: { en: string; fr?: string; de?: string }
    imageAlt?: string
    gatsbyImageSrc?: any
    youTubeId?: { en: string; fr?: string; de?: string }
  }
  quote: { en: string; fr?: string; de?: string }
}

export const homepageTestimonials: Testimonial[] = [
  {
    name: 'Nathan Thomas',
    position: { en: 'Head of Product', fr: 'Chef de produit', de: 'Head of Product' },
    company: 'Ricoh Europe',
    icon: 'testimonials/ricoh/ricoh-logo.webp',
    image: 'testimonials/ricoh/nathan-ricoh.webp',
    link: '',
    video: {
      imageSrc: {
        en: 'testimonials/ricoh/nathan-quote-thumbnail.webp',
        fr: 'testimonials/ricoh/nathan-quote-thumbnail-fr.webp',
        de: 'testimonials/ricoh/nathan-quote-thumbnail-de.webp',
      },
      imageAlt: 'Nathan Thomas, Head of Product at Ricoh Europe - user story',
      youTubeId: { en: 'sMgExfh8PS0', fr: 'wiEGpaLDB60' },
    },
    quote: {
      en: 'With airfocus we went from 5 features a month to 45 releases per sprint. airfocus is now the single source of truth for our 30+ product portfolio, boosting visibility across regions and stakeholders. We can now see exactly how our progress aligns with strategy.',
      fr: "Avec airfocus, nous sommes passés de 5 fonctionnalités par mois à 45 versions par sprint. airfocus est désormais l'unique source de vérité pour notre portefeuille de plus de 30 produits, améliorant la visibilité à travers les régions et les parties prenantes. Nous pouvons désormais voir exactement comment nos progrès s'alignent sur la stratégie.",
      de: 'airfocus hat unsere Produktentwicklung grundlegend transformiert - von 5 Features im Monat zu 45 Releases pro Sprint. airfocus ist jetzt unsere Single Source of Truth für unser vielfältiges Produktportfolio, sorgt für maximale Transparenz aller Stakeholder und verknüpft die Fortschritte klar mit unserer Strategie.',
    },
  },
  {
    name: 'Craig Unsworth',
    position: { en: 'CPO', fr: 'CPO', de: 'CPO' },
    company: 'Papirfly',
    icon: 'testimonials/papirfly/papirfly-logo.webp',
    image: 'testimonials/papirfly/papirfly-craig.webp',
    link: '',
    quote: {
      en: 'With airfocus we built a unified setup for 32 products and over 300 services in just 12 months (instead of 2-3 years). The power of the tool helped us navigate this complex transformation by providing constant clarity around our product vision & strategy.',
      fr: "Avec airfocus, système unifié pour 32 produits et plus de 300 services en 12 mois. La puissance de l'outil nous a aidés à naviguer cette transformation complexe en apportant une clarté constante sur la vision et la stratégie de nos produits.",
      de: 'Mit airfocus haben wir in nur 12 Monaten (statt 2-3 Jahren) ein einheitliches Setup für 32 Produkte und über 300 Services aufgebaut. Die vermittelte stetige Klarheit bezüglich Produktvision und -strategie half uns, diese komplexe Transformation zu bewältigen.',
    },
  },
  {
    name: 'Oliver Mitchell',
    position: { en: 'Product Ops Manager', fr: 'Responsable des opérations produit', de: 'Product Ops Manager' },
    company: 'Oodrive',
    icon: 'testimonials/oodrive/oodrive-logo.webp',
    image: 'testimonials/oodrive/oliver-oodrive.webp',
    link: '',
    quote: {
      en: 'airfocus stood out for its robust EU-based hosting. Its flexibility has allowed us to streamline our product management across multiple teams, ensuring our data stays protected while adapting to our unique requirements.',
      fr: "airfocus s'est distingué par son hébergement robuste basé dans l'UE. Sa flexibilité nous a permis de rationaliser notre gestion de produits à travers plusieurs équipes, garantissant la protection de nos données tout en s'adaptant à nos exigences spécifiques.",
      de: 'airfocus überzeugte uns durch sein robustes, EU-basiertes Hosting. Die Flexibilität der Plattform hat es uns ermöglicht, unser Produktmanagement über mehrere Teams hinweg zu optimieren, dabei unsere Daten geschützt zu halten und gleichzeitig auf unsere individuellen Anforderungen einzugehen.',
    },
  },
]

export const testimonials = [
  {
    name: 'Craig Unsworth',
    position: { en: 'CPO', fr: 'CPO', de: 'CPO' },
    company: 'Papirfly',
    icon: 'testimonials/papirfly/papirfly-logo.webp',
    image: 'testimonials/papirfly/papirfly-craig.webp',
    link: '',
    quote: {
      en: 'With airfocus we built a unified setup for 32 products and over 300 services in just 12 months (instead of 2-3 years). The power of the tool helped us navigate this complex transformation by providing constant clarity around our product vision & strategy.',
      fr: "Avec airfocus, système unifié pour 32 produits et plus de 300 services en 12 mois. La puissance de l'outil nous a aidés à naviguer cette transformation complexe en apportant une clarté constante sur la vision et la stratégie de nos produits.",
      de: 'Mit airfocus haben wir in nur 12 Monaten (statt 2-3 Jahren) ein einheitliches Setup für 32 Produkte und über 300 Services aufgebaut. Die vermittelte stetige Klarheit bezüglich Produktvision und -strategie half uns, diese komplexe Transformation zu bewältigen.',
    },
  },
  {
    name: 'Vinzenz Greger',
    position: { en: 'Managing director', fr: 'Directeur général', de: 'Geschäftsführer' },
    company: 'HolidayCheck',
    icon: 'testimonials/holidaycheck/holidaycheck-logo.webp',
    image: 'testimonials/holidaycheck/vinzenz-holidaycheck.png',
    link: '',
    quote: {
      en: 'The beauty of airfocus is its flexibility with customizable prioritization frameworks and custom fields that fit our business needs.',
      de: 'Das Schöne an airfocus ist seine Flexibilität mit anpassbaren Priorisierungs-Frameworks und benutzerdefinierten Feldern. Damit konnten wir airfocus perfekt auf unsere Bedürfnisse abstimmen.',
      fr: "La beauté d'airfocus est sa flexibilité avec des méthodes de priorisation personnalisables et des champs personnalisés qui s'adaptent à nos besoins commerciaux.",
    },
  },
  {
    name: 'Katie Bentzon',
    position: {
      en: 'Director of product operations',
      fr: 'Directrice des opérations produit',
      de: 'Leiterin Product Operations',
    },
    company: 'Bandwidth',
    icon: 'testimonials/bandwidth/bandwidth-logo.webp',
    image: 'testimonials/bandwidth/bandwidth-katie.webp',
    link: '',
    quote: {
      en: 'airfocus is a strategic product management platform that helps us prioritize better to see where we need to make investment and divestment decisions.',
      de: 'airfocus ist eine strategische Produktmanagement Plattform, die uns hilft, besser zu priorisieren und zu erkennen, wo wir Investitionen erhöhen oder verringern müssen.',
      fr: "airfocus est une plateforme stratégique de gestion produits qui nous aide à mieux hiérarchiser les priorités et savoir où prendre des décisions d'investissement et de désinvestissement.",
    },
  },
  {
    name: 'Marco Santoni',
    position: {
      en: 'Data product manager',
      fr: 'Responsable de la gestion des données produits',
      de: 'Geschäftsführer',
    },
    company: 'Flowe',
    icon: 'testimonials/flowe/flowe-logo.webp',
    image: 'testimonials/flowe/flowe-marco.png',
    link: '',
    quote: {
      en: "airfocus helps us understand what the quick wins or don't dos are and most importantly, what we should work on next.",
      de: "airfocus hilft uns zu verstehen, was die Quick Wins oder Don't Dos sind - und vor allem, woran wir als Nächstes arbeiten sollten.",
      fr: 'airfocus nous aide à comprendre où se trouve la valeur ajoutée la plus rapide ainsi que les choses à éviter, et plus important encore, ce sur quoi nous devrions travailler ensuite.',
    },
  },
  {
    name: 'Joakim Wissing',
    position: {
      en: 'Digital product director',
      fr: 'Directeur des produits numériques',
      de: 'Digital product director',
    },
    company: 'Oriflame',
    icon: 'testimonials/oriflame/oriflame-logo.webp',
    image: 'testimonials/oriflame/joakim-oriflame.webp',
    link: '',
    quote: {
      en: 'airfocus has been incredibly useful when it comes to aligning everyone around the vision and handling ideas. We are now focusing on what really matters.',
      de: 'airfocus ist extrem hilfreich, wenn es darum geht, alle an der Vision auszurichten und mit Ideen zu arbeiten. Wir fokussieren uns jetzt auf das, was wirklich zählt.',
      fr: 'airfocus a été incroyablement utile pour aligner tout le monde en interne sur notre vision produit et le traitement des idées. Nous pouvons désormais nous concentrer sur ce qui compte le plus.',
    },
  },
  {
    name: 'Amir Bohnenkamp',
    position: { en: 'CEO', fr: 'PDG', de: 'CEO' },
    company: 'Heyflow',
    icon: 'testimonials/heyflow/heyflow-logo.webp',
    image: 'testimonials/heyflow/amir-heyflow.jpeg',
    link: '',
    quote: {
      en: 'The ability to link random user feedback to the opportunities in our product backlog and roadmap was a game-changer for our product management team.',
      de: 'Die Möglichkeit, beliebige Feedbacks <span class="hide-on-small-medium">von Nutzerinnen und Nutzern</span> mit den Opportunities in unserem Produkt-Backlog und unserer Roadmap zu verknüpfen, war für unser <span class="hide-on-small-medium">Produktmanagement-</span><span class="hide-on-large-desktop">Produkt Management </span>Team ein großer Fortschritt.',
      fr: "La possibilité de lier des retours d'utilisateurs aux opportunités de notre backlog et roadmap a changé la donne pour notre équipe produits.",
    },
  },
]

export const roadmapsTestimonials: Testimonial[] = [
  {
    name: 'Vinzenz Greger',
    position: { en: 'Managing director', fr: 'Directeur général', de: 'Geschäftsführer' },
    company: 'HolidayCheck',
    icon: 'testimonials/holidaycheck/holidaycheck-logo.webp',
    image: 'testimonials/holidaycheck/vinzenz-holidaycheck.png',
    link: '',
    quote: {
      en: 'With airfocus, we see better processes and outcomes. I would recommend airfocus to people who work on roadmaps, who need to manage many incoming ideas, and who are obsessed with doing the right things.',
      fr: "La beauté d'airfocus est sa flexibilité, avec des cadres de priorisation personnalisables et des champs eux aussi personnalisés qui s'adaptent aux besoins de notre business.",
      de: 'Mit airfocus verbessern wir unsere Prozesse und Ergebnisse. Ich würde airfocus Teams empfehlen, die an Roadmaps arbeiten, viele Ideen verwalten und darauf bedacht sind, die richtigen Dinge zu tun.',
    },
  },

  {
    name: 'Neha Sondhi',
    position: { en: 'Product manager', fr: 'Chef de produit', de: 'Produktmanager' },
    company: 'Defined.ai',
    icon: 'testimonials/defined.ai/defined-ai.png',
    image: 'testimonials/defined.ai/neha-sondhi.png',
    link: '',

    quote: {
      en: "airfocus enabled us to do an entire end-to-end visualisation of the roadmap across different teams and departments. We're all aligned on what to do within the quarter or within the year.",
      fr: "airfocus nous permet de visualiser l'ensemble de notre roadmap à travers différentes équipes et départements. Nous sommes alignés sur nos objectifs trimestriels et annuels.",
      de: 'airfocus hat es uns ermöglicht, eine vollständige End-to-End-Visualisierung der Roadmap über verschiedene Teams <span class="hide-on-small-medium"> und Abteilungen </span> hinweg zu erstellen. Wir sind uns alle einig, was innerhalb des Quartals oder des Jahres zu tun ist.',
    },
  },
  {
    name: 'Jamie Hoyle',
    position: {
      en: 'Vice president of product',
      fr: 'Vice-président de la gestion des produits',
      de: 'Vice President of Product',
    },
    company: 'MirrorWeb',
    icon: 'testimonials/mirrorWeb/mirrorweb.png',
    image: 'testimonials/mirrorWeb/jamie-hoyle.jpeg',
    link: '',

    quote: {
      en: 'The software has proven to be a great frame of reference throughout this time and has given our whole team clarity in a time where our communications have changed significantly.',
      fr: "Cette plateforme est devenue le cadre de référence de notre travail. Elle nous a permis d'obtenir plus de clarté à un moment où notre communication changeait de manière conséquente.",
      de: 'Die Software hat sich in dieser Zeit als großartiger Bezugsrahmen erwiesen und unserem gesamten Team in einer Zeit, in der sich unsere Kommunikation stark verändert hat, Klarheit verschafft.',
    },
  },
]

export const prioritizationTestimonials: Testimonial[] = [
  {
    name: 'Bruno Ballester',
    position: { en: 'Product manager', fr: 'Chef de produit', de: 'Produktmanager' },
    company: 'Royal Canin',
    icon: 'testimonials/royalcanin/royal-canin-logo.webp',
    image: 'testimonials/royalcanin/bruno-ballester.jpeg',
    link: '',
    quote: {
      en: "I am happy to have airfocus to score my items and prioritize my backlog. What's great is that, because of this level of prioritization, we can all have an open discussion and have a better understanding of why we are doing certain things.",
      fr: "Je suis heureux d'avoir accès à airfocus pour noter les éléments et prioriser notre travail produit. Avec ce niveau de priorisation, nous avons tout ce qu'il nous faut pour communiquer de manière transparente et mieux comprendre le pourquoi de notre travail.",
      de: 'Ich bin froh, dass ich airfocus habe, um meine Aufgaben zu bewerten und meinen Backlog zu priorisieren. Folglich <span class="hide-on-small-medium">können wir offene Diskussionen führen und</span> haben <span class="hide-on-large-desktop">wir</span> ein besseres Verständnis dafür, wieso wir bestimmte Dinge tun.',
    },
  },

  {
    name: 'Vinzenz Greger',
    position: { en: 'Managing director', fr: 'Directeur général', de: 'Geschäftsführer' },
    company: 'HolidayCheck',
    icon: 'testimonials/holidaycheck/holidaycheck-logo.webp',
    image: 'testimonials/holidaycheck/vinzenz-holidaycheck.png',
    link: '',
    quote: {
      en: 'The beauty of airfocus is its flexibility with customizable prioritization frameworks and custom fields that fit our business needs.',
      fr: "La beauté d'airfocus est sa flexibilité, avec des cadres de priorisation personnalisables et des champs eux aussi personnalisés qui s'adaptent aux besoins de notre business.",
      de: 'Das Schöne an airfocus ist seine Flexibilität mit anpassbaren Priorisierungs-Frameworks und benutzerdefinierten Feldern<span class="hide-on-small-medium">. Damit konnten</span><span class="hide-on-large-desktop">, womit</span> wir airfocus perfekt auf unsere Bedürfnisse abstimmen <span class="hide-on-large-desktop">konnten</span>.',
    },
  },
  {
    name: 'Marco Santoni',
    position: {
      en: 'Data product manager',
      fr: 'Responsable de la gestion des données produits',
      de: 'Produktmanager',
    },
    company: 'Flowe',
    icon: 'testimonials/flowe/flowe-logo.webp',
    image: 'testimonials/flowe/flowe-marco.png',
    link: '',
    quote: {
      en: "airfocus helps us understand what the quick wins or don't dos are and most importantly, what we should work on next.",
      fr: 'airfocus nous aide à comprendre quels sont les gains rapides ou les points à éviter et, plus important encore, sur quoi porte notre prochaine étape.',
      de: "airfocus hilft uns zu verstehen, was die Quick Wins oder Don't Dos sind - und vor allem, woran wir als Nächstes arbeiten sollten.",
    },
  },
]

export const insightsTestimonials: Testimonial[] = [
  {
    name: 'Amir Bohnenkamp',
    position: { en: 'CEO', fr: 'PDG', de: 'CEO' },
    company: 'Heyflow',
    icon: 'testimonials/heyflow/heyflow-logo.webp',
    image: 'testimonials/heyflow/amir-heyflow.jpeg',
    link: '',
    quote: {
      en: 'The ability to link random user feedback to the opportunities in our product backlog and roadmap was a game-changer for our product management team.',
      fr: "La possibilité de lier des avis d'utilisateurs aux opportunités de notre carnet de commandes et de notre feuille de route a changé la donne pour notre équipe gestion de produits.",
      de: 'Die Möglichkeit, beliebige Feedbacks <span class="hide-on-small-medium">von Nutzerinnen und Nutzern</span> mit den Opportunities in unserem Produkt-Backlog und unserer Roadmap zu verknüpfen, war für unser <span class="hide-on-small-medium">Produktmanagement-</span><span class="hide-on-large-desktop">Produkt Management </span>Team ein großer Fortschritt.',
    },
  },

  {
    name: 'Joakim Wissing',
    position: {
      en: 'Digital product director',
      fr: 'Directeur des produits numériques',
      de: 'Digital product director',
    },
    company: 'Oriflame',
    icon: 'testimonials/oriflame/oriflame-logo.webp',
    image: 'testimonials/oriflame/joakim-oriflame.webp',
    link: '',
    quote: {
      en: 'airfocus has been incredibly useful when it comes to aligning everyone around the vision and handling ideas. We are now focusing on what really matters.',
      fr: "airfocus a été incroyablement utile pour faire comprendre à tous quelle était la vision d'ensemble et pour traiter les idées. On peut désormais se consacrer à ce qui compte vraiment.",
      de: 'airfocus ist extrem hilfreich, wenn es darum geht, alle an der Vision auszurichten und mit Ideen zu arbeiten. Wir fokussieren uns jetzt auf das, was wirklich zählt.',
    },
  },
  {
    name: 'Jamie Hoyle',
    position: {
      en: 'Vice president of product',
      fr: 'Vice-président de la gestion des produits',
      de: 'Vice president of product',
    },
    company: 'MirrorWeb',
    icon: 'testimonials/mirrorWeb/mirrorweb.png',
    image: 'testimonials/mirrorWeb/jamie-hoyle.jpeg',
    link: '',
    quote: {
      en: 'The software has proven to be a great frame of reference throughout this time and has given our whole team clarity in a time where our communications have changed significantly.',
      fr: "Cette plateforme est devenue le cadre de référence de notre travail. Elle nous a permis d'obtenir plus de clarté à un moment où notre communication changeait de manière conséquente.",
      de: 'Die Software hat sich in dieser Zeit als großartiger Bezugsrahmen erwiesen und unserem gesamten Team in einer Zeit, in der sich unsere Kommunikation stark verändert hat, Klarheit verschafft.',
    },
  },
]

export const portalTestimonials: Testimonial[] = [
  {
    name: 'Amir Bohnenkamp',
    position: { en: 'CEO', fr: 'PDG', de: 'CEO' },
    company: 'Heyflow',
    icon: 'testimonials/heyflow/heyflow-logo.webp',
    image: 'testimonials/heyflow/amir-heyflow.jpeg',
    link: '',
    quote: {
      en: 'The ability to link random user feedback to the opportunities in our product backlog and roadmap was a game-changer for our product management team.',
      fr: "La possibilité de lier des avis d'utilisateurs aux opportunités de notre carnet de commandes et de notre feuille de route a changé la donne pour notre équipe gestion de produits.",
      de: 'Die Möglichkeit, beliebige Feedbacks <span class="hide-on-small-medium">von Nutzerinnen und Nutzern</span> mit den Opportunities in unserem Produkt-Backlog und unserer Roadmap zu verknüpfen, war für unser <span class="hide-on-small-medium">Produktmanagement-</span><span class="hide-on-large-desktop">Produkt Management </span>Team ein großer Fortschritt.',
    },
  },
  {
    name: 'Joakim Wissing',
    position: { en: 'Digital product director', fr: 'Directeur produits numériques', de: 'Digital product director' },
    company: 'Oriflame',
    icon: 'testimonials/oriflame/oriflame-logo.webp',
    image: 'testimonials/oriflame/joakim-oriflame.webp',
    link: '',
    quote: {
      en: 'airfocus has been incredibly useful when it comes to aligning everyone around the vision and handling ideas. We are now focusing on what really matters.',
      fr: "airfocus a été incroyablement utile pour faire comprendre à tous quelle était la vision d'ensemble et pour traiter les idées. On peut désormais se consacrer à ce qui compte vraiment.",
      de: 'airfocus ist extrem hilfreich, wenn es darum geht, alle an der Vision auszurichten und mit Ideen zu arbeiten. Wir fokussieren uns jetzt auf das, was wirklich zählt.',
    },
  },
]

export const enterpriseTestimonials: Testimonial[] = [
  {
    name: 'Joakim Wissing',
    position: { en: 'Digital product director', fr: 'Directeur produits numériques', de: 'Digital product director' },
    company: 'Oriflame',
    icon: 'testimonials/oriflame/oriflame-logo.webp',
    image: 'testimonials/oriflame/joakim-oriflame.webp',
    link: '',
    quote: {
      en: 'airfocus has been incredibly useful when it comes to aligning everyone around the vision and handling ideas. We are now focusing on what really matters.',
      fr: "airfocus a été incroyablement utile pour faire comprendre à tous quelle était la vision d'ensemble et pour traiter les idées. On peut désormais se consacrer à ce qui compte vraiment.",
      de: 'airfocus ist extrem hilfreich, wenn es darum geht, alle an der Vision auszurichten und mit Ideen zu arbeiten. Wir fokussieren uns jetzt auf das, was wirklich zählt.',
    },
  },
  {
    name: 'Ben Chisell',
    position: { en: 'CPO', fr: 'CPO', de: 'CPO' },
    company: 'Paysend',
    icon: 'testimonials/paysend/paysend-logo.png',
    image: 'testimonials/paysend/ben-chisell.jpeg',
    link: '',
    quote: {
      en: "By using airfocus, we've seen an increase in the impact that we've had on the objectives and key results that we set for the company each quarter.",
      fr: "En utilisant airfocus, nous avons constaté une augmentation de l'impact que nous avons sur les objectifs et résultats clés que nous fixons pour l'entreprise chaque trimestre.",
    },
  },
]

export const careersTestimonials: Testimonial[] = [
  {
    name: 'Employee',
    position: { en: 'Customer Success Manager (CSM)' },
    company: 'airfocus',
    icon: 'testimonials/glassdoor-rating.webp',
    image: 'testimonials/glassdoor-logo.webp',
    link: 'https://www.glassdoor.com/Overview/Working-at-airfocus-EI_IE3247690.11,19.htm',
    quote: {
      en: 'Surrounded by young intelligent people and diversity, I think that this place is close to perfection in terms of employee happiness, understanding, flexibility, mental health, collaboration, honesty, team playing.',
    },
  },
  {
    name: 'Employee',
    position: { en: 'Sales Development Representative (SDR)' },
    company: 'airfocus',
    icon: 'testimonials/glassdoor-rating.webp',
    image: 'testimonials/glassdoor-logo.webp',
    link: 'https://www.glassdoor.com/Overview/Working-at-airfocus-EI_IE3247690.11,19.htm',
    quote: {
      en: 'The team is friendly, kind and very interested in the product. A really motivated bunch to keep making airfocus amazing. Management is flexible and understanding of employees needs. Super experience.',
    },
  },
  {
    name: 'Employee',
    position: { en: 'Sales Development Representative (SDR)' },
    company: 'airfocus',
    icon: 'testimonials/kununu-logo.webp',
    image: 'testimonials/kununu-icon.webp',
    link: 'https://www.kununu.com/de/airfocus/',
    quote: {
      en: 'What I find especially outstanding is that we can all be ourselves and are not being judged. Also the support and coherence within my department and also cross functional is something I really value.',
    },
  },
  {
    name: 'Employee',
    position: { en: 'Marketing Manager' },
    company: 'airfocus',
    icon: 'testimonials/kununu-logo.webp',
    image: 'testimonials/kununu-icon.webp',
    link: 'https://www.kununu.com/de/airfocus/',
    quote: {
      en: 'airfocus ist ein Start-up wie es sein sollte - zumindest nach meiner Vorstellung. Dinge passieren schnell, die Hierarchie ist flach und der Techstack auf dem neusten Stand. Absolut nette Leute, ein tolles Produkt und trotz des inhärenten Risikos von Fremdfinanzierung ein sehr zukunftsfestes Produkt.',
    },
  },
]
